export default "__VITE_ASSET__Ddx2prmF__"